import {TeammateModel} from '../../../libs/shared/core/src/models/api/teammateModel';

export function resolveTeammatesFromTeammatesAndCircles(
  selectedTeammateIds: ReadonlyArray<number>,
  selectedCircleIds: ReadonlyArray<number>,
  allFlatTeammates: ReadonlyArray<TeammateModel>,
) {
  const allResolvedTeammates = new Set(selectedTeammateIds);

  if (selectedCircleIds.length === 0) {
    return allResolvedTeammates;
  }

  allFlatTeammates.forEach((teammate) => {
    if (teammate.circleIds.some((id) => selectedCircleIds.includes(id))) {
      allResolvedTeammates.add(teammate.id);
    }
  });

  return allResolvedTeammates;
}
